var NotSelectableNavigationItem = /** @class */ (function () {
    function NotSelectableNavigationItem() {
        this.x = 0;
        this.y = 0;
    }
    NotSelectableNavigationItem.prototype.activate = function (active) {
    };
    NotSelectableNavigationItem.prototype.canNavigateToDirection = function (keyCode) {
        return true;
    };
    NotSelectableNavigationItem.prototype.isSelectable = function () {
        return false;
    };
    NotSelectableNavigationItem.prototype.isSubscribed = function () {
        return false;
    };
    NotSelectableNavigationItem.prototype.onBack = function () {
    };
    NotSelectableNavigationItem.prototype.onEnter = function () {
    };
    return NotSelectableNavigationItem;
}());
export { NotSelectableNavigationItem };
